import axios from "axios";

const GroupChatAPI = {

    async getFaqItems() {
        let pld = (await axios.get(`/faq-items`)).data;
        return pld;
    },

    async createFaqItem(data = {}) {
        let pld = (await axios.post(`/faq-items`, {
            ...data
        })).data;
        return pld;
    },

    async updateFaqItem(data = {}) {
        let pld = (await axios.put(`/faq-items`, {
            ...data
        })).data;
        return pld;
    },

    async deleteFaqItem(id) {
        let pld = (await axios.delete(`/faq-items/${id}`)).data;
        return pld;
    },


    async getGroupMessages(groupId, fromTimestamp) {
        let pld = (await axios.get(`/v3/chat/group/${groupId}/since/${fromTimestamp}`)).data.result;
        return pld;
    },

    async getGroupInfo(groupId) {
        let pld = (await axios.get(`/v3/chat/group/${groupId}/info`)).data;
        return pld;
    },

    async readAllMessages(groupId) {
        let pld = (await axios.get(`/v3/chat/group/${groupId}/read-all`)).data;
        return pld;
    },

    async toggleChatGroupActivity(groupId, active) {
        let pld = (await axios.post(`/v3/chat/group/${groupId}/toggle-active`, {
            active: active
        })).data;
        return pld;
    },


    async sendMessageToGroup(groupId, userId, message, fileUrl) {
        let pld = (await axios.post(`/v3/chat/group/${groupId}`, {
            userId: userId,
            message: message,
            fileUrl: fileUrl
        })).data.result;
        return pld;
    },

    async updateMessage(messageId, message) {
        let pld = (await axios.put(`/v3/chat/group/message/${messageId}`, {
            message: message
        })).data.result;
        return pld;
    },

    async deleteMessage(messageId) {
        let pld = (await axios.delete(`/v3/chat/group/message/${messageId}`)).data;
        return pld;
    }


};

export default GroupChatAPI;
